module.exports = __webpack_public_path__ + "static/media/Zasady1.8252345b.jpg";